import type { Recording, SearchRecording, Transcript } from './types'

export const apiBaseUrl = 'https://r2-huaren-server.logging.top'
const tokenKey = 'huaren_audio_token'

export const getToken = () => localStorage.getItem(tokenKey)
export const setToken = (token: string | null) => token ? localStorage.setItem(tokenKey, token) : localStorage.removeItem(tokenKey)

const request = async <T>(token: string, path: string, init: RequestInit = {}): Promise<T> => {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...init,
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json', ...init.headers }
  })
  if (response.status === 401) throw new Error('登录已失效，请重新登录。')
  const data = await response.json()
  if (!response.ok || data.success === false) throw new Error(data.error || '请求失败，请稍后重试。')
  return data as T
}

export const getRecordings = async (token: string) => {
  const data = await request<{ recordings: Recording[] }>(token, '/api/recordings')
  return data.recordings
}

export const searchTranscript = async (token: string, query: string) => {
  const data = await request<{ recordings: SearchRecording[]; totalMatches: number }>(token, `/api/transcript-search?query=${encodeURIComponent(query)}`)
  return data
}

export const getTranscript = (token: string, audioFileName: string) =>
  request<Transcript>(token, '/api/transcript', { method: 'POST', body: JSON.stringify({ audioFileName }) })

export const getSummary = async (token: string, audioFileName: string) => {
  const data = await request<{ streamUrl: string }>(token, '/api/summary-url', {
    method: 'POST',
    body: JSON.stringify({ summaryFileName: `summary/${audioFileName.replace(/\.[^.]+$/, '.txt')}` })
  })
  const response = await fetch(data.streamUrl)
  if (!response.ok) throw new Error('无法读取 AI 总结。')
  return response.text()
}

export const download = async (token: string, fileKey: string, downloadName: string) => {
  const data = await request<{ downloadUrl: string }>(token, '/api/download-url', {
    method: 'POST', body: JSON.stringify({ fileKey, downloadName })
  })
  window.open(data.downloadUrl, '_blank', 'noopener,noreferrer')
}
